import * as TYPES from './types';

export const articleSelected = (articleId) => ({
  type: TYPES.EDUCATION_ARTICLE_SELECTED,
  state: {
    selectedArticleId: articleId,
  },
});

export const articlesLoaded = (articles) => ({
  type: TYPES.ARTICLES_LOADED_SUCCESS,
  state: {
    educationArticles: articles,
  },
});

export const articlesLoadFailure = (message) => ({
  type: TYPES.ARTICLES_LOADED_FAILURE,
  error: message,
});

export const decrementReadCount = () => ({
  type: TYPES.DECREMENT_READ_COUNT,
});

export const inlineArticleUrlLoaded = (url) => ({
  type: TYPES.SINGLE_ARTICLE_LOADED,
  state: {
    inPageArticleUrl: url,
  },
});

export const unreadCounted = (unreadCount) => ({
  type: TYPES.UNREAD_COUNT_SUCCESS,
  state: {
    unreadArticlesCount: unreadCount,
  },
});

export const unreadCountFailure = (message) => ({
  type: TYPES.UNREAD_COUNT_FAILURE,
  error: message,
});

export const archivedCounted = (archivedCount) => ({
  type: TYPES.ARCHIVED_COUNT_SUCCESS,
  state: {
    archivedArticlesCount: archivedCount,
  },
});

export const archivedCountFailure = (message) => ({
  type: TYPES.ARCHIVED_COUNT_FAILURE,
  error: message,
});

export const viewPreferenceRead = (response) => ({
  type: TYPES.VIEW_PREFERENCE_LOADED_SUCCESS,
  state: {
    viewSelectionPreference: response,
  },
});

export const viewPreferenceReadFailure = (message) => ({
  type: TYPES.VIEW_PREFERENCE_LOADED_FAILED,
  error: message,
});

export const viewPreferenceSet = (response) => ({
  type: TYPES.VIEW_PREFERENCE_SAVED_SUCCESS,
  value: response,
});

export const viewPreferenceSetFailure = (message) => ({
  type: TYPES.VIEW_PREFERENCE_SAVED_FAILURE,
  error: message,
});
